import { render, staticRenderFns } from "./SysLanguageModal.vue?vue&type=template&id=c28d95f6&"
import script from "./SysLanguageModal.vue?vue&type=script&lang=js&"
export * from "./SysLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports